import { render, staticRenderFns } from "./AlertGlobal.vue?vue&type=template&id=9980fe52"
import script from "./AlertGlobal.vue?vue&type=script&lang=js"
export * from "./AlertGlobal.vue?vue&type=script&lang=js"
import style0 from "./AlertGlobal.vue?vue&type=style&index=0&id=9980fe52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports